import React from "react"
import { Select } from "../select/Select"
import axios from "axios"

const SelectEntries = ({
  onChange,
  collections,
  field,
  form,
  ...inputProps
}) => {
  const [options, setOptions] = React.useState([])

  React.useEffect(() => {
    const requests = collections.map(collection =>
      axios.get(`/api/collections/${collection}/entries?fields=id,title`)
    )
    axios.all(requests).then(
      axios.spread((...res) => {
        const entries = res.reduce((acc, item) => {
          acc = [
            ...acc,
            ...item.data.data.map(entry => ({
              value: entry.id,
              label: entry.title,
            })),
          ]
          return acc
        }, [])
        entries.sort((a, b) => a.label.localeCompare(b.label))
        setOptions(entries)
      })
    )
  }, [collections])

  return <Select {...{ options, onChange, field, form, inputProps }} />
}
export { SelectEntries }
